import { Reveal } from "@/components/Reveal";

export default function SectionHeading({ eyebrow, title, desc, align = "center", as: Tag = "h2" }) {
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-right";
  return (
    <Reveal className={`flex flex-col gap-4 ${alignCls}`}>
      {eyebrow && (
        <span className="flex items-center gap-3 text-xs font-bold tracking-[0.25em] text-gold">
          <span className="h-px w-8 bg-gold/60" />
          {eyebrow}
          {align === "center" && <span className="h-px w-8 bg-gold/60" />}
        </span>
      )}
      <Tag className="max-w-3xl text-2xl font-bold leading-snug sm:text-3xl lg:text-4xl" dangerouslySetInnerHTML={{ __html: title }} />
      {desc && <p className="max-w-2xl text-base leading-relaxed text-slate-400">{desc}</p>}
    </Reveal>
  );
}
